module.exports = __webpack_public_path__ + "static/screenshot-1-f8d5c2c394f94ffdcbd4c5443020fdb2.png";